// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Breadcrumbs({ icon, title, route, light }) {
  const routes = route.slice(0, -1);
  const formatTitle = (text) => {
  if (!text) return "";
  return text
    .replace(/[-_]/g, " ")           // replace - or _ with space
    .replace(/([a-z])([A-Z])/g, "$1 $2") // add space before capital letters
    .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letter of each word
};


  return (
    <MDBox ml={{ xs: 0, xl: 1 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) =>
              light ? white.main : grey[600],
          },
        }}
      >
        {routes.map((el) => {
          // Map 'track' to 'dashboard' route
          let linkPath = `/${el}`;

          if (el.toLowerCase() === "track") {
            linkPath = "/dashboard";
          } else if (el === "ViewHospitalProfile") {
            linkPath = "/HospitalProfile";
          } else if(el === "ViewDoctorProfile"){
            linkPath = "/Doctors";
          }else if(el === "view-care-coordinator"){
            linkPath = "/carecoordinatorsdetails";
          }else if(el === "ViewPatientProfile"){
            linkPath = "/PatientRegistration";
          }else if(el === "ViewDoctorDetails"){
            linkPath = "/PatientLoginDoctorDetails";
          }else if(el === "PatientViewDetails"){
            linkPath = "/DoctorLoginPatientDetails";
          }
          
         // const linkPath = el.toLowerCase() === 'track' ? '/dashboard' : `/${el}`;
          

          return (
            <Link to={linkPath} key={el}>
              <MDTypography
                component="span"
                variant="button"
                fontWeight="regular"
                textTransform="capitalize"
                color={light ? "white" : "dark"}
                opacity={light ? 0.8 : 0.5}
                sx={{ lineHeight: 0 }}
              >
                {formatTitle(el)}
              </MDTypography>
            </Link>
          );
        })}
        <MDTypography
          variant="button"
          fontWeight="bold"
          textTransform="capitalize"
          color={light ? "white" : "dark"}
          sx={{ lineHeight: 0 }}
        >
          {title.replace("-", " ")}
        </MDTypography>
      </MuiBreadcrumbs>
    </MDBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;